module.exports = __webpack_public_path__ + "static/media/appstore-4c.eb6a5079.png";